 document.addEventListener('DOMContentLoaded', function () {
    const tileOverlay = document.querySelector('.tile-overlay');
    const footer = document.querySelector('.footer');

    if (tileOverlay && footer) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              tileOverlay.style.opacity = '0';
              tileOverlay.style.pointerEvents = 'none';
            } else {
              tileOverlay.style.opacity = '1';
              tileOverlay.style.pointerEvents = 'auto';
            }
          });
        },
        {
          root: null,
          threshold: 0.1
        }
      );

      observer.observe(footer);
    }
  });